import createAction from 'loankeeper-common/helpers/createAction'
import { actionTypes } from './constants'

export const destroyInstance = (instanceName) =>
  createAction(actionTypes.saga.DESTROY_INSTANCE, undefined, { instanceName })

export const registerInstance = (instanceName) =>
  createAction(actionTypes.regUnreg.REGISTER_INSTANCE, undefined, { instanceName })

export const unregisterInstance = (instanceName) =>
  createAction(actionTypes.regUnreg.UNREGISTER_INSTANCE, undefined, { instanceName })
